/*********
 Sticky header
 **********/
// add sticky class to header sections
document.querySelector('#announcement').parentElement.classList.add('announcementSticky');
document.querySelector('#header').parentElement.classList.add('headerSticky');


/**************
 Mobile Nav
 ***************/

// open dropdown on hover
// document.querySelectorAll(".openMegaMenu").forEach(element => {
//     element.addEventListener("mouseenter", function () {
//
//         // check if the megamenu for this element is already open
//         if (document.querySelector(`.dropdownNavItem[data-target="${this.dataset.target}"]`).classList.contains('active')) {
//             return;
//         }
//
//
//         // flip down arrow icon
//         this.classList.toggle("active");
//
//         document.querySelector('#dropdownExit').classList.add("active");
//
//
//         // close all dropdown navs
//         document.querySelectorAll(".dropdownNavItem").forEach(element => {
//             if (element.dataset.target !== this.dataset.target) {
//                 element.classList.remove('active');
//             }
//         });
//
//         // close search if open
//         document.querySelector('#search').classList.remove('active');
//
//         // open dropdown nav
//         let target = this.getAttribute("data-target");
//         document.querySelector(`.dropdownNavItem[data-target="${target}"]`).classList.toggle('active');
//
//     });
// });

// open the dropdown navigation Desktop Only
document.querySelectorAll(".openMegaMenu")?.forEach(element => {
    element.addEventListener("click", function () {
        // flip down arrow icon
        this.classList.toggle("active");

        document.querySelector('#dropdownExit').classList.add("active");


        // close all dropdown navs
        document.querySelectorAll(".dropdownNavItem").forEach(element => {
            if (element.dataset.target !== this.dataset.target) {
                element.classList.remove('active');
            }
        });

        // close search if open
        document.querySelector('#search').classList.remove('active');

        // open dropdown nav
        let target = this.getAttribute("data-target");
        document.querySelector(`.dropdownNavItem[data-target="${target}"]`).classList.toggle('active');

    });
});

// close the dropdown navigation
document.querySelector("#dropdownExit")?.addEventListener("mouseenter", function () {
    this.classList.remove("active");
    document.querySelectorAll('.dropdownNavItem').forEach(element => {
        element.classList.remove('active');
    });
});


/*********
 Search Dropdown
 **********/
document.querySelectorAll('.headerIconsSearch').forEach(element => {
    element.addEventListener('click', function () {
        // on mobile, the header search button opens the mobile slider
        if (window.innerWidth < 800) {
            openNav();
            return;
        }

        document.querySelector('#search').classList.toggle('active');
        document.querySelector('#searchExit').classList.toggle("active");


        // close all other dropdowns if open
        document.querySelectorAll('.dropdownNavItem').forEach(element => {
            element.classList.remove('active');
        });

    });
})


// close the search
document.querySelector("#searchExit")?.addEventListener("click", function () {
    this.classList.remove("active");
    document.querySelector('#search').classList.remove('active');
});


// listen for text changes in predictive search Desktop
document.querySelector('#searchWrapContentFormQuery').addEventListener('input', function () {

    // wait 300 ms then predict search
    setTimeout(async () => {
        await predictiveSearch(document.querySelector('#searchWrapContentFormQuery').value);
    }, 300);
});

// Predictive Search API Desktop Listen for submit
document.querySelector('#searchWrapContentForm').addEventListener('submit', async function (e) {
    e.preventDefault();

    // predict search
    await predictiveSearch(this.querySelector('input').value);
});


// Predictive Search API Desktop
async function predictiveSearch(query) {
    if (query === '') {
        return;
    }

    // get the id of the header
    let headerId = document.querySelector('#header').parentElement.id;
    // parse out shopify-section- from the id
    headerId = headerId.replace('shopify-section-', '');

    await fetch(window.Shopify.routes.root + `search/suggest?q=${encodeURIComponent(query)}&section_id=${headerId}`)
        .then((response) => {
            return response.text();
        })
        .then((text) => {

            // create temp div to parse html
            const html = document.createElement('div');
            html.innerHTML = text;
            const search = html.querySelector(`#searchWrapContentSearch`);

            // insert search results
            if (search && search.innerHTML.trim().length) {
                document.querySelector(`#searchWrapContentSearch`).innerHTML = search.innerHTML;
            }
        })
        .catch(e => {
            console.error(e);
        });
}


// listen for text changes in predictive search Mobile
document.querySelector('#sliderSearchFormQuery').addEventListener('input', function () {

    // wait 300 ms then predict search
    setTimeout(async () => {
        await predictiveSearchMobile(document.querySelector('#sliderSearchFormQuery').value);
    }, 300);
});

// Predictive Search API Mobile Listen for submit
document.querySelector('#sliderSearchForm').addEventListener('submit', async function (e) {
    e.preventDefault();

    // predict search
    await predictiveSearchMobile(this.querySelector('input').value);
});


// Predictive Search API Mobile
async function predictiveSearchMobile(query) {
    if (query === '') {
        return;
    }

    // get the id of the header
    let headerId = document.querySelector('#header').parentElement.id;
    // parse out shopify-section- from the id
    headerId = headerId.replace('shopify-section-', '');

    await fetch(window.Shopify.routes.root + `search/suggest?q=${encodeURIComponent(query)}&section_id=${headerId}`)
        .then((response) => {
            return response.text();
        })
        .then((text) => {

            // create temp div to parse html
            const html = document.createElement('div');
            html.innerHTML = text;
            const search = html.querySelector(`#sliderSearchResults`);

            // insert search results
            if (search && search.innerHTML.trim().length) {
                document.querySelector(`#sliderSearchResults`).classList.add('active');
                document.querySelector(`#sliderSearchResults`).innerHTML = search.innerHTML;


                // listen for UNDO search
                document.querySelector('#sliderSearchResultsRemove').addEventListener('click', function () {
                    // remove any HTML
                    document.querySelector(`#sliderSearchResults`).innerHTML = '';

                    // Reset the form
                    document.querySelector('#sliderSearchForm').reset();
                });
            }
        })
        .catch(e => {
            console.error(e);
        });
}


/*********
 Mobile slider
 **********/

// setup mobile Dropdowns
document.querySelectorAll(".sliderDropTop").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();

    // remove html of search results
    document.querySelector(`#sliderSearchResults`).innerHTML = '';
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#slider"));

/*********
 Localization
 **********/

// open popup
document.querySelector('#headerIconsLocalization').addEventListener('click', function () {

    if (document.querySelector('#headerIconsWrapPopup').classList.contains('active')) {
        document.querySelector('#headerIconsWrapPopup').classList.remove('active');
        return;
    }

    // show
    document.querySelector('#headerIconsWrapPopup').classList.add('active');

    // listen for clicks outside of the popup and close it
    document.addEventListener('click', function (e) {
        if (!document.querySelector('#headerIconsWrapPopup').contains(e.target) && !document.querySelector('#headerIconsLocalization').contains(e.target)) {
            document.querySelector('#headerIconsWrapPopup').classList.remove('active');
        }
    });
});


// listen for localization buttons
document.querySelectorAll('.headerIconsWrapPopupBtn').forEach(element => {
    element.addEventListener('click', function () {
        // set country Param and reload
        let url = new URL(window.location.href);
        url.searchParams.set('country', element.dataset.iso);
        window.location.href = url;
    });
});
